import { useIdentity } from "@/auth/identity";
import { Button } from "@/components/ui/button";
import { AlertTriangle, RefreshCw } from "lucide-react";

const ErrorPage = () => {
  const { loginWithRedirect } = useIdentity();

  const handleRetry = () => {
    loginWithRedirect();
  };

  return (
    <div className="min-h-screen bg-gray-100 flex items-center justify-center p-4">
      <div className="bg-white p-8 rounded-lg shadow-lg max-w-md w-full text-center">
        <div className="mx-auto w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mb-4">
          <AlertTriangle className="h-8 w-8 text-red-600" />
        </div>

        <h1 className="text-2xl font-bold text-gray-900 mb-2">
          Error de Autenticación
        </h1>

        <p className="text-gray-600 mb-6">
          Hubo un problema con la autenticación. Por favor, intente iniciar
          sesión nuevamente.
        </p>

        <div className="space-y-3">
          <Button onClick={handleRetry} className="w-full">
            <RefreshCw className="h-4 w-4 mr-2" />
            Reintentar Inicio de Sesión
          </Button>

          <Button
            variant="outline"
            onClick={() => window.location.reload()}
            className="w-full"
          >
            Recargar Página
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ErrorPage;
